import { render, staticRenderFns } from "./PatrolPoints.vue?vue&type=template&id=6f573f80&scoped=true"
import script from "./PatrolPoints.vue?vue&type=script&lang=js"
export * from "./PatrolPoints.vue?vue&type=script&lang=js"
import style0 from "./PatrolPoints.vue?vue&type=style&index=0&id=6f573f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f573f80",
  null
  
)

export default component.exports